module.exports = __webpack_public_path__ + "static/media/clockwork.e40b1391.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Intro/assets/clockwork.pdf
// module id = 119
// module chunks = 0